var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPicked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 12 13"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#picked_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#picked_svg__b)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E7AA0E",
  d: "M.643 0A.643.643 0 0 0 0 .643v2.374a3.214 3.214 0 0 0 3.214 3.214h.33a.643.643 0 0 0 .643-.642V.643A.643.643 0 0 0 3.544 0zm.643 3.017V1.286H2.9V4.92a1.93 1.93 0 0 1-1.615-1.903M11.357 0A.643.643 0 0 1 12 .643v2.374a3.213 3.213 0 0 1-3.214 3.214h-.33a.643.643 0 0 1-.643-.642V.643A.643.643 0 0 1 8.456 0zm-.643 3.017V1.286H9.1V4.92a1.93 1.93 0 0 0 1.615-1.903M6 7.417a.643.643 0 0 1 .643.644v2.653h2.241a.643.643 0 1 1 0 1.286H3.115a.643.643 0 1 1 0-1.286h2.242V8.061A.643.643 0 0 1 6 7.418"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#picked_svg__c)",
  d: "M3 .002a.43.43 0 0 0-.428.429v4.712a3.429 3.429 0 0 0 6.857 0V.431A.43.43 0 0 0 9 .002z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "picked_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h12v12H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "picked_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "picked_svg__c",
  x1: 6,
  x2: 6,
  y1: 0.002,
  y2: 8.572,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.395,
  stopColor: "#FFC71E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BE9928"
})))));
export default SvgPicked;